export default __webpack_public_path__ + "static/media/template_pro__0024_3---DavidPete.6fe31bc9.png";